/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 *
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      Camille CHAREL
 * @date        04/03/2020 17:47
 * @copyright   Copyright (c) 2002-2020 IRIS Interactive, Inc. (https://www.iris-interactive.fr)
 * @package     SampledefaultTheme
 */

import Ux from '@troyes/js/services/ux';
import Form from '@troyes/js/services/form';
import Slider from '@troyes/js/services/slider';

export default class FrontPage {
    
    static #$form           = $( '[data-id="wpiris-affinity-form"]' );
    static #$filters        = $( '[data-id="wpiris-affinity-filters"]' );
    static #$filters_result = $( '[data-id="wpiris-affinity-filters-result"]' );
    static #select          = '[data-id="wpiris-affinity-filter-item"]';
    static #$wrapper        = $( '[data-id="wpiris-affinity-results"]' );
    static #values          = "";
    
    constructor()
    {
        FrontPage.initializeSvgMap();
        FrontPage.initializeAffinity();
        FrontPage.scrollytelling();
    }
    
    static initializeSvgMap()
    {
        if ( $( '.strateMapSvg' ).length > 0 ) {
            let strate_map    = $( '#strateMap' );
            let svg_container = $( '[data-id="wpiris-svg-map"]' );
            let map_load      = 0;
            
            $( window ).on( 'load scroll', function () {
                let scroll_top = $( this ).scrollTop();
                
                if ( scroll_top <= strate_map.outerHeight() && map_load == 0 ) {
                    strate_map.outerHeight();
                    map_load = 1;
                    $.get( svg_container.data( 'svg-map' ), function ( response ) {
                        svg_container.append( $( response ).find( 'svg' ) );
                        $( document ).trigger( 'svg_map_loaded' );
                    } );
                }
            } );
            
            $( document ).on( 'svg_map_loaded', function () {
                let $zone_preview         = $( "[data-zone-preview]" ),
                    $zone                 = $( '[data-zone]' ),
                    $zone_default         = $( '[data-zone="troyes"]' ),
                    $zone_preview_default = $( '[data-zone-preview="troyes"]' );
                
                $zone.hover(
                    function () {
                        let id = $( this ).attr( 'data-zone' );
                        $zone_preview.removeClass( 'active' );
                        $zone.removeClass( 'active' );
                        $( '[data-zone=' + id + ']' ).addClass( 'active' );
                        $( '[data-zone-preview=' + id + ']' ).addClass( 'active' );
                    }, function () {
                        $zone_preview.removeClass( 'active' );
                        $zone.removeClass( 'active' );
                        $zone_default.addClass( 'active' );
                        $zone_preview_default.addClass( 'active' );
                    }
                );
                
                $( document ).on( 'click', '[data-zone]', function () {
                    let id = $( this ).attr( 'data-zone' );
                    let href = ($('[data-zone-preview="'+id+'"] a').attr('href'));
                    window.location = href;
                } );
            } );
            
        }
    }
    
    static initializeAffinity()
    {
        const trigger = '[data-trigger="wpiris-affinity-filters-toggle"]';
        
        $( document ).on( 'click', trigger, function ( e ) {
            e.preventDefault();
            FrontPage.#$filters.toggleClass( 'open' );
        } );
        
        $( document ).on( 'change', FrontPage.#select, function () {
            FrontPage.#values = FrontPage.getSelectValues();
            FrontPage.buildSlider();
            FrontPage.buildFilters();
        } );
    
        $( document ).on( 'click', '[data-trigger="wpiris-affinity-filters-reset"]', function ( e ) {
            e.preventDefault();
            FrontPage.#values = "";
            FrontPage.buildSlider();
            FrontPage.buildFilters();
            $( '[data-trigger="wpiris-affinity-filters-reset"]' ).addClass( 'hide' );
        } );
        
    }
    
    static getSelectValues()
    {
        let datas = [];
        $( FrontPage.#select ).each( function () {
            let value = $( this ).val();
            let name  = $( this ).attr( "name" );
            if ( value !== '' && value !== null ) {
                datas.push( {
                                name: name,
                                value: value,
                            } );
            }
        } );
        return datas;
    }
    
    static buildSlider()
    {
        FrontPage.#$wrapper.addClass( 'loading' );
        $.ajax(
            {
                url: Theme.ajaxURL,
                data: {
                    'action': 'affinity_slider',
                    'datas': FrontPage.#values
                },
                method: "POST",
            }
        ).done( function ( response ) {
            FrontPage.#$wrapper.html( response );
            FrontPage.#$wrapper.removeClass( 'loading' );
            Slider.initializeAffinitySlider();
            Ux.initializeLazy();
        } );
    }
    
    static buildFilters()
    {
        FrontPage.#$filters_result.addClass( 'loading' );
        $.ajax(
            {
                url: Theme.ajaxURL,
                data: {
                    'action': 'affinity_filters',
                    'datas': FrontPage.#values
                },
                method: "POST",
            }
        ).done( function ( response ) {
            FrontPage.#$filters_result.html( response );
            Form.customizeSelect();
            FrontPage.#$filters_result.removeClass( 'loading' );
            FrontPage.displayCurrentFilters();
            FrontPage.resetFilters();
        } );
    }
    
    static displayCurrentFilters()
    {
        const $element = $( '[data-id="wpiris-affinity-filters-count"]' );
        
        if ( $element.length > 0 ) {
            let filters_selected = FrontPage.getSelectValues();
            $element.html( filters_selected.length );
        }
    }
    
    static resetFilters()
    {
        const element        = '[data-trigger="wpiris-affinity-filters-reset"]';
        let filters_selected = FrontPage.getSelectValues();
        
        if ( filters_selected.length > 0 ) {
            $( element ).removeClass( 'hide' );
        }
    }
    
    static scrollytelling()
    {
        // Cache la pastille quand on commence à etre dans la strate
        $( '.strateScrollytellingList' ).hover( function() {
            $( '.strateScrollytellingMapPastille' ).fadeOut();
        }, function() {
            $( '.strateScrollytellingMapPastille' ).fadeIn();
        } );
        
        // Hover des vignettes pour ajout du tracé sur la carte
        const element = $( '[data-trigger="wpiris-change-scrollytelling"]' );
        const target = $( '#strateScrollytellingMapTrail' );
        
        element.hover( function() {
            const pathSvg = $( this ).attr( 'data-value' );
            target.find( 'img' ).remove();
            target.append( '<img />' );
            target.find( 'img' ).attr( 'src', pathSvg );
            setTimeout( function() {
                target.find( 'img' ).addClass( 'active' );
            }, 100 );
        }, function() {
            target.find( 'img' ).remove();
        });
    }
}
